import axios from "axios";


let baseURL = import.meta.env.VITE_API_URL?.trim()

// Safety check – fallback ONLY if undefined
if (!baseURL) {
  baseURL = 'https://backend.adarshpayroll.com/api'


}

export const api = axios.create({
  baseURL,
  headers: {
    "Content-Type": "application/json",
  },
});

// Attach token
api.interceptors.request.use(
  (config) => {
    const token =

      localStorage.getItem('token') || sessionStorage.getItem('token')

    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`
    }

    return config
  },
  (error) => Promise.reject(error)
)

      
// Handle 401
api.interceptors.response.use(
  (response) => {
    if (
      response.config.responseType === "blob" ||
      response.data instanceof Blob
    ) {
      return response;
    }

    if (
      response.data &&
      typeof response.data === "object" &&
      "data" in response.data
    ) {
      return {
        ...response,
        data: response.data,
      };
    }
    return response;
  },
  (error) => {
    if (error.response?.status === 401) {

      localStorage.removeItem('token')
      sessionStorage.removeItem('token')
      window.location.href = '/login'

     
    }
    return Promise.reject(error);
  }
);


export default api


